
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nscbb871445a12dca8f6c9652ad7a69f93en from './en.yaml'
            i18n.addResourceBundle('en', 'cbb871445a12dca8f6c9652ad7a69f93', flattenObject(nscbb871445a12dca8f6c9652ad7a69f93en), true, true);
        
        export default 'cbb871445a12dca8f6c9652ad7a69f93';
    